<template>
  <v-card :flat="flat">
    <vue-perfect-scrollbar
      ref="scrollbar"
      :class="['agreements-tab__scroll', { 'agreements-tab__scroll--flat': flat }]">
      <v-card-text class="agreements-tab pa-3">
        <div v-if="loading" class="agreements-tab__state">
          <v-progress-circular indeterminate color="k-orange-linear"></v-progress-circular>
        </div>

        <div v-else-if="errorState" class="agreements-tab__state">
          <v-icon class="mb-2" color="error">fas fa-exclamation-triangle</v-icon>
          <p class="mb-3">No se pudieron cargar los convenios.</p>
          <v-btn outline color="k-orange-linear" @click="fetchAgreements">Reintentar</v-btn>
        </div>

        <div v-else-if="!agreements.length" class="agreements-tab__state">
          <v-icon class="agreements-tab__empty-icon mb-3">fas fa-file-alt</v-icon>
          <p>Este cliente no tiene convenios registrados.</p>
        </div>

        <div v-else>
          <agreement-card
            v-for="(agreement, index) in agreements"
            :key="agreement.id"
            :agreement="agreement"
            :expanded="expandedId === agreement.id"
            @toggle="toggleAgreement(agreement.id, index)" />
        </div>
      </v-card-text>
    </vue-perfect-scrollbar>
  </v-card>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import AgreementCard from './AgreementCard';

export default {
  components: {
    VuePerfectScrollbar,
    AgreementCard,
  },
  props: {
    customer: {
      type: Object,
      default: () => ({}),
    },
    tab: {
      type: String,
      default: 'tab-7',
    },
    flat: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      agreements: [],
      loading: false,
      errorState: false,
      expandedId: null,
    };
  },
  mounted() {
    if (this.shouldFetch(this.tab)) {
      this.fetchAgreements();
    }
  },
  watch: {
    tab(value) {
      if (this.shouldFetch(value)) {
        this.fetchAgreements();
      }
    },
    'customer.id'(id, previousId) {
      if (id && id !== previousId && this.shouldFetch(this.tab)) {
        this.fetchAgreements();
      }
    },
  },
  methods: {
    shouldFetch(tab) {
      return this.customer && this.customer.id && (this.flat || tab === 'tab-7');
    },
    fetchAgreements() {
      if (!this.customer || !this.customer.id) {
        return;
      }

      this.loading = true;
      this.errorState = false;
      this.expandedId = null;

      this.axios.get(`customers/${this.customer.id}/agreements`)
        .then(({ data }) => {
          this.agreements = Array.isArray(data.data) ? data.data : [];

          if (this.agreements.length) {
            this.expandedId = this.agreements[0].id;
          }
        })
        .catch(() => {
          this.errorState = true;
          this.agreements = [];
          this.expandedId = null;
        })
        .finally(() => {
          this.loading = false;
          this.updateScrollbar();
        });
    },
    toggleAgreement(id) {
      this.expandedId = this.expandedId === id ? null : id;
      this.updateScrollbar();
    },
    updateScrollbar() {
      this.$nextTick(() => {
        const { scrollbar } = this.$refs;

        if (scrollbar && typeof scrollbar.update === 'function') {
          scrollbar.update();
        }
      });

      // Recalcular tras la animación del acordeón
      setTimeout(() => {
        const { scrollbar } = this.$refs;

        if (scrollbar && typeof scrollbar.update === 'function') {
          scrollbar.update();
        }
      }, 320);
    },
  },
};
</script>

<style scoped>
.agreements-tab__scroll {
  height: 392px;
}

.agreements-tab__scroll--flat {
  height: calc(70vh - 160px);
}

.agreements-tab {
  min-height: 200px;
}

.agreements-tab__state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  text-align: center;
  color: #666663;
}

.agreements-tab__empty-icon {
  font-size: 48px;
  color: #C8C6C0;
}
</style>



// WEBPACK FOOTER //
// src/components/agreements/AgreementsTab.vue